// ─────────────────────────────────────────
// i18n/page.ts — Qual página está aberta
// O site é multipágina: cada HTML declara a sua chave em
// <body data-page="…">, e é ela que decide qual fatia da
// Translation o renderer aplica.
// Tauvior — IA Edge-first
// ─────────────────────────────────────────

import type { PageKey } from './types';

/** Todas as páginas do site, na ordem em que aparecem no menu. */
export const PAGE_KEYS: readonly PageKey[] = [
  'home',
  'grid',
  'advisory',
  'sobre',
  'contato',
];

/**
 * Lê a chave da página no <body>. Retorna null quando o atributo está
 * ausente ou desconhecido — o chamador decide o que fazer, em vez de
 * receber um 'home' silencioso e renderizar a página errada.
 */
export function getPageKey(): PageKey | null {
  const value = document.body.dataset.page;
  return PAGE_KEYS.includes(value as PageKey) ? (value as PageKey) : null;
}
